import { Expose } from 'class-transformer';
import { Model } from '../../shared-features/models/model';
import { AiMessageAuthor } from '@shared-features/enums';
import { MatTableDataSource } from '@angular/material/table';

export interface IAiMessageDataPreview {
  tool: string;
  columns: string[];
  rows: Record<string, any>[];
}
export interface IChatMessage {
  content: string;
  author: AiMessageAuthor;
  table?: {
    columns: string[];
    dataSource: MatTableDataSource<Record<string, unknown>>;
  };
  isLoading?: boolean;
}

export class IAiMessage extends Model {
  @Expose() sessionId: string;
  @Expose() answer: string;
  @Expose() dataPreview: IAiMessageDataPreview;

  constructor() {
    super();
  }
}
